(() => {
  'use strict';

  const controlledHandles = new Set([
    'wago', 'wago-connectors', 'wago-221-series-lever-nuts', 'wago-splicing-connectors', 'wago-terminal-blocks',
    'wago-pcb-terminals', 'wago-pluggable', 'wago-winsta', 'wago-automation', 'wago-hmi', 'wago-ethernet-switches',
    'wago-power-supplies', 'wago-marking-systems', 'leuze', 'leuze-sensors', 'leuze-photoelectric',
    'leuze-inductive-sensors', 'leuze-ultrasonic', 'leuze-fiber-optic', 'leuze-fork-sensors',
    'leuze-light-curtains', 'leuze-safety-light-curtains', 'leuze-laser-scanners', 'leuze-barcode-readers',
    'leuze-cables', 'panasonic', 'panasonic-plcs', 'panasonic-sensors', 'panasonic-photoelectric', 'panasonic-cx400-photoelectric', 'panasonic-pressure-sensors', 'panasonic-safety',
    'panasonic-safety-light-curtains', 'panasonic-safety-controllers', 'panasonic-safety-door-switches',
    'panasonic-safety-enabling-switches', 'panasonic-safety-accessories', 'panasonic-servo', 'panasonic-hmi', 'panasonic-motion', 'agastat',
  ]);
  const normalizeSku = (value) => String(value || '').trim().toUpperCase().replace(/\s+/g, '').replace(/[‐‑–—−]/g, '-');
  const categoryKey = (value) => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

  function ensureDiscoveryStyles() {
    if (document.getElementById('usac-source-discovery-runtime-styles')) return;
    const style = document.createElement('style');
    style.id = 'usac-source-discovery-runtime-styles';
    style.textContent = [
      '.usac-source-discovery{margin:0 0 76px;padding:clamp(20px,4vw,32px);border:1px solid #cbddea;border-radius:14px;background:linear-gradient(145deg,#f5faff 0%,#eef6fb 100%);box-shadow:0 12px 30px rgba(16,54,89,.06)}',
      '.usac-source-discovery *{box-sizing:border-box}.usac-source-discovery h2{margin:0 0 7px;color:#102b48;font-size:clamp(22px,3vw,28px);letter-spacing:-.025em}.usac-source-discovery p{margin:0;color:#536b82;font-size:14px;line-height:1.55}',
      '.usac-source-discovery__filters{display:grid;gap:14px;margin-top:24px}.usac-source-discovery__filter-intro{display:grid!important;grid-column:1/-1;grid-template-columns:44px minmax(0,1fr) auto;align-items:center;gap:12px;width:100%;min-height:72px;border:2px solid #c87800!important;border-radius:12px!important;padding:13px 16px!important;background:linear-gradient(135deg,#ffe56f,#ffc940)!important;color:#173a59!important;font:800 15px inherit;text-align:left;box-shadow:0 5px 0 #a96000,0 10px 22px rgba(119,76,0,.2)!important;cursor:pointer;transition:transform .16s ease,box-shadow .16s ease,background .16s ease}.usac-source-discovery__filter-intro:hover{background:linear-gradient(135deg,#ffec8f,#ffd34f)!important;transform:translateY(-1px);box-shadow:0 6px 0 #a96000,0 12px 24px rgba(119,76,0,.24)!important}.usac-source-discovery__filter-intro:focus-visible{outline:4px solid rgba(0,90,160,.3);outline-offset:3px}.usac-source-discovery__filter-intro:before{display:grid;width:44px;height:44px;place-items:center;border-radius:11px;background:#075f96;color:#fff;content:"⚙";font-size:21px;line-height:1}.usac-source-discovery__filter-intro:after{content:"Expand filters  ▾";border-radius:999px;padding:7px 11px;background:#173a59;color:#fff;font-size:11px;font-weight:900;letter-spacing:.03em;text-transform:uppercase;white-space:nowrap}.usac-source-discovery__filter-intro[aria-expanded="true"]:after{content:"Hide filters  ▴"}.usac-source-discovery__filter-intro strong{display:block}.usac-source-discovery__filter-intro span{display:block;margin-top:3px;color:#4f3a00;font-size:12px;font-weight:650}.usac-source-discovery__filter-controls{display:grid;grid-column:1/-1;grid-template-columns:repeat(4,minmax(190px,1fr));gap:10px;align-items:start}.usac-source-discovery__filter-controls[hidden]{display:none}',
      '.usac-source-discovery__exact{display:flex;grid-column:1/-1;align-items:center;gap:12px;padding:10px 12px;border:1px solid #c5d9e7;border-radius:9px;background:rgba(255,255,255,.78);color:#254967;font-size:12px;font-weight:800}.usac-source-discovery__exact-input{width:min(100%,420px);min-height:38px;border:1px solid #aec6d7;border-radius:7px;padding:0 12px;background:#fff;color:#102b48;font:600 13px inherit}.usac-source-discovery__exact-input:focus{border-color:#0875b5;outline:3px solid rgba(8,117,181,.14)}.usac-source-discovery__exact-hint{grid-column:1/-1;margin:-8px 12px 0;color:#536b82;font-size:12px;line-height:1.45}',
      '.usac-source-discovery__filter{min-width:0;margin:0;padding:12px;border:1px solid #c8dbe8;border-radius:9px;background:rgba(255,255,255,.92);box-shadow:0 3px 9px rgba(21,62,94,.04)}.usac-source-discovery__filter legend{display:flex;align-items:center;gap:8px;margin:0 0 10px;color:#183f60;font-size:13px;font-weight:850}.usac-source-discovery__filter legend:before{display:grid;width:28px;height:28px;flex:0 0 28px;place-items:center;border-radius:7px;background:#0875b5;color:#fff;content:"01";font-size:10px;font-weight:900;letter-spacing:.06em}.usac-source-discovery__filter:nth-of-type(2) legend:before{background:#668d0d;content:"02"}.usac-source-discovery__filter:nth-of-type(3) legend:before{background:#d27818;content:"03"}.usac-source-discovery__filter:nth-of-type(4) legend:before{background:#7353a6;content:"04"}',
      '.usac-source-discovery__filter-options{display:grid;grid-template-columns:1fr;gap:5px;max-height:248px;overflow-y:auto;padding-right:4px;scrollbar-gutter:stable}.usac-source-discovery__filter-chip{min-height:36px;border:1px solid #c4d6e3;border-radius:6px;padding:7px 9px;background:#f9fcfe;color:#315572;font:700 11px/1.3 inherit;text-align:left;cursor:pointer;transition:border-color .16s ease,background .16s ease,box-shadow .16s ease}.usac-source-discovery__filter-chip img{display:block;width:100%;height:92px;margin:0 0 8px;object-fit:contain}.usac-source-discovery__filter-chip:hover{border-color:#5c96bc;background:#eff8fd;box-shadow:0 3px 8px rgba(16,80,123,.1)}.usac-source-discovery__filter-chip[aria-pressed="true"]{border-color:#628b17;background:#eff8d9;color:#405f0b;box-shadow:inset 0 0 0 1px #9bc840,0 3px 8px rgba(95,132,16,.12)}.usac-source-discovery__filter-chip:focus-visible{outline:3px solid rgba(0,90,160,.28);outline-offset:2px}',
      '.usac-source-discovery__reset{grid-column:1/-1;justify-self:start;border:0;background:transparent;color:#005aa0;font:800 12px inherit;text-decoration:underline;cursor:pointer}.usac-source-discovery__results{display:grid;gap:9px;margin-top:22px}.usac-source-discovery__status{padding:11px 13px;border-left:3px solid #668d0d;border-radius:4px;background:#f4f9e8;color:#405d24;font-size:13px;font-weight:750}.usac-source-discovery__result{display:flex;justify-content:space-between;gap:14px;align-items:center;padding:14px 16px;border:1px solid #d2e0e9;border-radius:9px;background:#fff;box-shadow:0 3px 9px rgba(16,54,89,.035)}.usac-source-discovery__result-body{display:grid;gap:5px;min-width:0}.usac-source-discovery__result-details{color:#526b82;font-size:12px;line-height:1.45}.usac-source-discovery__result--with-image{display:grid;grid-template-columns:96px minmax(0,1fr) auto;min-height:112px}.usac-source-discovery__result-image{display:grid;width:96px;height:82px;place-items:center;overflow:hidden;border-radius:8px;background:#f4f7f9}.usac-source-discovery__result-image img{display:block;width:100%;height:100%;object-fit:contain}.usac-source-discovery__result:hover{border-color:#8db4cc;box-shadow:0 6px 14px rgba(16,54,89,.08)}.usac-source-discovery__result a{color:#005aa0;font-size:14px;font-weight:800;text-decoration:none}.usac-source-discovery__result a:hover{color:#003b68;text-decoration:underline}.usac-source-discovery__result span{border-radius:999px;padding:5px 9px;background:#edf3f7;color:#587086;font-size:11px;font-weight:800;letter-spacing:.03em;white-space:nowrap}',
      '.usac-source-discovery__collision{display:grid;gap:9px;margin-top:10px;padding:14px;border:1px solid #e2b34c;border-radius:9px;background:#fff9e8;color:#5b4617}.usac-source-discovery__collision strong{font-size:14px}.usac-source-discovery__collision p{margin:0;font-size:13px;line-height:1.45}.usac-source-discovery__collision-options{display:flex;flex-wrap:wrap;gap:7px}.usac-source-discovery__collision-options button{border:1px solid #c9921c;border-radius:999px;padding:7px 10px;background:#fff;color:#634b11;font:700 12px inherit;cursor:pointer}.usac-source-discovery__collision-options button:hover{background:#fff0bf}',
      '@media(max-width:900px){.usac-source-discovery__filter-controls{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:600px){.usac-source-discovery{padding:20px 16px}.usac-source-discovery__filter-controls{grid-template-columns:1fr}.usac-source-discovery__filter-intro{grid-template-columns:40px minmax(0,1fr);padding:12px}.usac-source-discovery__filter-intro:before{width:40px;height:40px}.usac-source-discovery__filter-intro:after{grid-column:1/-1;text-align:center}.usac-source-discovery__filter-intro span{grid-column:2}.usac-source-discovery__result{align-items:flex-start;flex-direction:column;gap:7px}.usac-source-discovery__result--with-image{display:grid;grid-template-columns:78px minmax(0,1fr)}.usac-source-discovery__result-image{width:78px;height:72px}.usac-source-discovery__result--with-image>span{grid-column:2}}',
    ].join('');
    document.head.appendChild(style);
  }

  function requestedRouteKey(root, manifest) {
    if (root.dataset.sourceRoute) return root.dataset.sourceRoute;
    const handle = root.dataset.collectionHandle;
    if (handle === 'wago') {
      const query = new URLSearchParams(window.location.search);
      if (query.get('hub') === 'interface-electronic') {
        const interfaceRoutes = {
          'current-transformers': 'wago-interface-current-transformers',
          relays: 'wago-interface-relays',
          'interface-modules': 'wago-interface-modules',
        };
        return interfaceRoutes[query.get('family')] || 'wago-interface-electronic';
      }
    }
    if (handle === 'wago-automation') {
      return {
        'plc-cpu-modules': 'wago-automation-plc-cpu-modules',
        'fieldbus-couplers': 'wago-automation-fieldbus-couplers',
      }[new URLSearchParams(window.location.search).get('category')] || handle;
    }
    if (handle === 'wago-terminal-blocks') {
      return {
        'topjob-s': 'wago-topjob-s-series',
        'feed-through': 'wago-feedthrough-components',
      }[new URLSearchParams(window.location.search).get('family')] || handle;
    }
    if (handle === 'leuze-fiber-optic') {
      const family = new URLSearchParams(window.location.search).get('family');
      if (family === 'amplifiers') return 'leuze-fiber-optic-amplifiers';
      if (family === 'fibers') return 'leuze-fiber-optics';
    }
    if (handle === 'leuze-photoelectric') {
      const family = new URLSearchParams(window.location.search).get('family');
      return {
        'retroreflective-photoelectric-sensors': 'leuze-photoelectric-retroreflective-photoelectric-sensors',
        'diffuse-sensors': 'leuze-photoelectric-diffuse-sensors',
        'through-beam-photoelectric-sensors': 'leuze-photoelectric-through-beam-photoelectric-sensors',
      }[family] || handle;
    }
    if (handle === 'leuze-safety-light-curtains') {
      const family = new URLSearchParams(window.location.search).get('family');
      return {
        elc100: 'leuze-safety-light-curtains-elc100',
        elc150: 'leuze-safety-light-curtains-elc150',
        'mlc-300': 'leuze-safety-light-curtains-mlc-300',
        'mlc-500': 'leuze-safety-light-curtains-mlc-500',
        'mlc-udc': 'leuze-safety-light-curtains-mlc-udc',
      }[family] || handle;
    }
    if (handle === 'wago-221-series-lever-nuts') {
      return new URLSearchParams(window.location.search).get('scope') === 'accessories'
        ? 'wago-221-mounting-carriers'
        : handle;
    }
    if (handle === 'wago-hmi') {
      const family = new URLSearchParams(window.location.search).get('family');
      return {
        standard: 'wago-hmi-standard',
        advance: 'wago-hmi-advance',
        marine: 'wago-hmi-marine',
      }[family] || handle;
    }
    if (handle === 'panasonic-plcs') {
      const query = new URLSearchParams(window.location.search).get('q') || '';
      return manifest.aliases?.[query.toUpperCase().replace(/[^A-Z0-9]/g, '')] || handle;
    }
    const panasonicFamilyRoutes = {
      'panasonic-sensors': {
        fiber: 'panasonic-fiber-sensors',
        proximity: 'panasonic-proximity-sensors',
        pressure: 'panasonic-pressure-sensors',
        displacement: 'panasonic-displacement-sensors',
        measurement: 'panasonic-measurement-sensors',
      },
      'panasonic-photoelectric': {
        cx400: 'panasonic-cx400-photoelectric',
      },
      'panasonic-servo': { 'minas-a7': 'panasonic-minas-a7', 'minas-a6': 'panasonic-minas-a6' },
      'panasonic-hmi': {
        wh: 'panasonic-wh-hmi',
        gt704: 'panasonic-gt704-hmi',
        gt703: 'panasonic-gt703-hmi',
        gt707: 'panasonic-gt707-hmi',
      },
    };
    const family = new URLSearchParams(window.location.search).get('family');
    return panasonicFamilyRoutes[handle]?.[family] || handle;
  }

  function productUrl(candidate, exactSkuIndex) {
    const handles = exactSkuIndex?.exactSkuToHandles?.[normalizeSku(candidate.sku)] || [];
    if (handles.length === 1) return '/products/' + handles[0];
    if (candidate.handle) return '/products/' + candidate.handle;
    return '/search?q=' + encodeURIComponent(candidate.sku) + '&type=product&options%5Bprefix%5D=none';
  }

  const exactProductImageAssets = Object.freeze({
    '2773-402': 'usac-wago-2773-402.png',
    '2773-403': 'usac-wago-2773-403.png',
    '2773-404': 'usac-wago-2773-404.png',
    '2773-405': 'usac-wago-2773-405.png',
    '2773-406': 'usac-wago-2773-406.png',
    '2773-408': 'usac-wago-2773-408.png',
  });
  const productImageCache = new Map();
  async function productImage(candidate, exactSkuIndex, assetBase = '') {
    const asset = exactProductImageAssets[normalizeSku(candidate.sku)];
    if (asset && assetBase) return assetBase + asset;
    const url = productUrl(candidate, exactSkuIndex);
    if (!url.startsWith('/products/')) return '';
    if (productImageCache.has(url)) return productImageCache.get(url);
    const request = fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : null)
      .then((product) => product?.featured_image ? (product.featured_image.startsWith('//') ? 'https:' + product.featured_image : product.featured_image) : '')
      .catch(() => '');
    productImageCache.set(url, request);
    return request;
  }

  function filterValueLabel(filterKey, value) {
    if (filterKey === 'terminal_color') {
      return String(value).replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
    }
    if (filterKey !== 'conductor_cross_section') return value;
    const metricValues = [...String(value).matchAll(/(\d+(?:\.\d+)?)\s*mm(?:2|²)/gi)].map((match) => match[1]);
    const awgValues = [...String(value).matchAll(/#?(\d+)\s*awg/gi)].map((match) => match[1]);
    const unique = (values) => [...new Set(values)];
    const metricRange = unique(metricValues).map(Number).sort((left, right) => left - right);
    const awgRange = unique(awgValues).map(Number).sort((left, right) => right - left);
    const range = (values, unit) => (
      values.length > 1 ? values[0] + '–' + values.at(-1) + ' ' + unit : values[0] + ' ' + unit
    );
    return metricValues.length && awgValues.length
      ? range(metricRange, 'mm²') + ' · ' + range(awgRange, 'AWG')
      : value;
  }

  function visualCard(choice, assetBase) {
    const hasChildren = Array.isArray(choice.children) && choice.children.length > 0;
    const link = document.createElement(hasChildren ? 'article' : 'a');
    link.className = 'usac-source-discovery__visual-card';
    if (!hasChildren) link.href = choice.url;
    if (choice.imageAsset) {
      const image = document.createElement('img');
      image.src = assetBase + choice.imageAsset;
      const brand = choice.url?.startsWith('/collections/wago')
        ? 'WAGO'
        : choice.url?.includes('leuze')
          ? 'Leuze'
          : 'Panasonic Industry';
      image.alt = brand + ' ' + choice.label + ' product family';
      image.loading = 'lazy';
      link.appendChild(image);
    }
    const body = document.createElement('div');
    body.className = 'usac-source-discovery__visual-body';
    const label = document.createElement('strong');
    label.textContent = choice.label;
    const description = document.createElement('p');
    description.textContent = choice.description;
    if (hasChildren) {
      const primary = document.createElement('a');
      primary.className = 'usac-source-discovery__visual-primary';
      primary.href = choice.url;
      primary.appendChild(label);
      body.append(primary, description);
    } else {
      body.append(label, description);
    }
    if (Number.isFinite(choice.sourceCount)) {
      const meta = document.createElement('span');
      meta.className = 'usac-source-discovery__visual-meta';
      meta.textContent = choice.sourceCount + ' source-classified products';
      body.appendChild(meta);
    }
    if (hasChildren) {
      const children = document.createElement('div');
      children.className = 'usac-source-discovery__visual-children';
      children.setAttribute('aria-label', choice.label + ' child collections');
      choice.children.forEach((child) => {
        const childLink = document.createElement('a');
        childLink.href = child.url;
        childLink.innerHTML = '<strong></strong><span></span>';
        childLink.querySelector('strong').textContent = child.label;
        childLink.querySelector('span').textContent = child.description + ' →';
        children.appendChild(childLink);
      });
      body.appendChild(children);
    }
    link.appendChild(body);
    return link;
  }

  function renderVisualChoices(root, heading, copy, choices, assetBase) {
    const grid = document.createElement('div');
    grid.className = 'usac-source-discovery__visual-grid';
    choices.forEach((choice) => grid.appendChild(visualCard(choice, assetBase)));
    root.append(heading, copy, grid);
  }

  function renderGuidedPanasonicSensorFamily(root, heading, copy, choice, assetBase) {
    heading.textContent = 'Panasonic ' + choice.label;
    copy.textContent = choice.description;
    const panel = document.createElement('div');
    panel.className = 'usac-source-discovery__guided-family';
    const image = document.createElement('img');
    image.src = assetBase + choice.imageAsset;
    image.alt = 'Panasonic Industry ' + choice.label + ' manufacturer category';
    const body = document.createElement('div');
    const title = document.createElement('h3');
    title.textContent = 'Choose with verified source guidance';
    const explanation = document.createElement('p');
    explanation.textContent = 'This manufacturer family is not yet mapped to a complete, source-approved Shopify product set. No unrelated product grid or invented technical filter is shown. Use Panasonic’s family guide, search an exact part number above, or ask US Automation Controls for selection help.';
    const actions = document.createElement('div');
    actions.className = 'usac-source-discovery__guided-actions';
    const source = document.createElement('a');
    source.href = choice.sourceUrl;
    source.target = '_blank';
    source.rel = 'noopener noreferrer';
    source.textContent = 'View Panasonic family guide';
    const support = document.createElement('a');
    support.href = '/collections/request-quote?product=' + encodeURIComponent(choice.label);
    support.textContent = 'Request selection help';
    actions.append(source, support);
    body.append(title, explanation, actions);
    panel.append(image, body);
    root.append(heading, copy, panel);
  }

  function renderVisualGroups(root, heading, copy, groups, assetBase) {
    const groupsRoot = document.createElement('div');
    groupsRoot.className = 'usac-source-discovery__visual-groups';
    groups.forEach((group) => {
      const choices = group.choices.filter((choice) => choice.sourceCount === undefined || choice.sourceCount > 0);
      if (!choices.length) return;
      const section = document.createElement(group.collapsed ? 'details' : 'section');
      section.className = 'usac-source-discovery__visual-group' + (group.secondary ? ' usac-source-discovery__visual-secondary' : '');
      if (group.collapsed) {
        const summary = document.createElement('summary');
        summary.textContent = group.label;
        section.appendChild(summary);
      } else {
        const groupHeading = document.createElement('h3');
        groupHeading.textContent = group.label;
        section.appendChild(groupHeading);
      }
      const description = document.createElement('p');
      description.textContent = group.description;
      const grid = document.createElement('div');
      grid.className = 'usac-source-discovery__visual-grid';
      choices.forEach((choice) => grid.appendChild(visualCard(choice, assetBase)));
      section.append(description, grid);
      groupsRoot.appendChild(section);
    });
    root.append(heading, copy, groupsRoot);
  }

  function renderPanasonicHubChrome(root, assetBase) {
    root.classList.add('usac-source-discovery--panasonic-hub');
    const masthead = document.createElement('div');
    masthead.className = 'usac-panasonic-hub__masthead';
    const logo = document.createElement('img');
    logo.src = window.USAC_PANASONIC_LOGO_URL || assetBase + 'usac-panasonic-industry-logo.svg';
    logo.alt = 'Panasonic Industry';
    logo.width = 220;
    logo.height = 52;
    const actions = document.createElement('div');
    actions.className = 'usac-panasonic-hub__actions';
    actions.innerHTML = '<a href="/collections/panasonic">Current product families</a><a href="/collections/request-quote">Selection support</a>';
    masthead.append(logo, actions);
    root.appendChild(masthead);
  }

  function renderPanasonicHubSupport(root) {
    const support = document.createElement('div');
    support.className = 'usac-panasonic-hub__support';
    support.innerHTML = '<div><strong>Customer support</strong><span>Share your application, existing part number, or required product family with US Automation Controls.</span></div><a href="/collections/request-quote">Contact our team</a>';
    root.appendChild(support);
  }

  function renderDiscovery(root, route, routeTechnical = {}, exactSkuIndex = {}) {
    root.replaceChildren();
    const heading = document.createElement('h2');
    heading.textContent = route.label;
    const copy = document.createElement('p');
    const query = new URLSearchParams(window.location.search);
    const selectedCategory = query.get('category');
    const selectedFamily = query.get('family');
    const activePanasonicHmiFamily = root.dataset.collectionHandle === 'panasonic-hmi' && query.has('family');
    const activeWagoHmiFamily = root.dataset.collectionHandle === 'wago-hmi' && query.has('family');
    const activeWagoInterfaceFamily = (
      root.dataset.collectionHandle === 'wago'
      && query.get('hub') === 'interface-electronic'
      && query.has('family')
    );
    const activeChoice = route.visualChoices?.find((choice) => (
      choice.sourceCategoryKey === selectedCategory || choice.sourceTagKey === selectedCategory
    ));
    const activeCategory = activeChoice?.sourceCategoryKey === selectedCategory ? activeChoice : undefined;
    const activeSourceTag = activeChoice?.sourceTagKey === selectedCategory ? activeChoice : undefined;
    const assetBase = root.dataset.assetBase || '';
    const activeGuidedPanasonicSensorFamily = (
      root.dataset.collectionHandle === 'panasonic-photoelectric'
      && route.familyChoices?.find((choice) => choice.family === selectedFamily && choice.guidedOnly)
    );
    copy.textContent = route.customerFilterState === 'guided-only'
      ? route.reason || 'Choose an approved configuration identifier. A customer-facing technical filter is not available until its canonical Shopify product linkage is reviewed.'
      : routeTechnical.technicalScope
        ? 'Use the verified technical refinements below to narrow source-classified products. The exact manufacturer part-number search remains available for every product in this route.'
        : 'Only products explicitly classified in the approved manufacturer import are shown here. Shopify smart-collection membership is not used for these results.';

    if (route.visualGroups?.length && !activeCategory && !activeSourceTag && !root.dataset.sourceRoute) {
      copy.textContent = route.familyChoiceCopy || copy.textContent;
      const panasonicHub = root.dataset.collectionHandle === 'panasonic';
      if (panasonicHub) renderPanasonicHubChrome(root, assetBase);
      renderVisualGroups(root, heading, copy, route.visualGroups, assetBase);
      if (panasonicHub) renderPanasonicHubSupport(root);
      return;
    }

    if (activeGuidedPanasonicSensorFamily) {
      renderGuidedPanasonicSensorFamily(root, heading, copy, activeGuidedPanasonicSensorFamily, assetBase);
      return;
    }

    if (route.familyChoices?.length) {
      copy.textContent = route.familyChoiceCopy || copy.textContent;
      if (route.familyChoices.some((choice) => choice.imageAsset)) {
        renderVisualChoices(root, heading, copy, route.familyChoices, assetBase);
        return;
      }
      const choices = document.createElement('div');
      choices.className = 'usac-source-discovery__choices';
      route.familyChoices.forEach((choice) => {
        const link = document.createElement('a');
        link.className = 'usac-source-discovery__choice';
        link.href = choice.url;
        link.innerHTML = '<strong></strong><span></span>';
        link.querySelector('strong').textContent = choice.label;
        link.querySelector('span').textContent = choice.description;
        choices.appendChild(link);
      });
      root.append(heading, copy, choices);
      return;
    }

    if (route.visualChoices?.length && !activeCategory && !activeSourceTag && !root.dataset.sourceRoute) {
      copy.textContent = route.familyChoiceCopy || 'Start with a WAGO product family. Every path is tied to the manufacturer import, with related accessories kept separate from the main product journey.';
      renderVisualChoices(root, heading, copy, route.visualChoices.filter((choice) => choice.sourceCount === undefined || choice.sourceCount > 0), assetBase);
      return;
    }

    const blockedExactSkuPathSkus = new Set(routeTechnical.blockedExactSkuPathSkus || []);
    const candidates = route.candidates
      .filter((candidate) => !blockedExactSkuPathSkus.has(normalizeSku(candidate.sku)))
      .filter((candidate) => (
        (!activeCategory || categoryKey(candidate.sourceCategory) === activeCategory.sourceCategoryKey)
        && (!activeSourceTag || candidate.tags.includes(activeSourceTag.sourceTagValue))
      ))
      .map((candidate) => ({ ...candidate, technical: routeTechnical.technicalBySku?.[candidate.sku] || {} }));
    root.dataset.approvedProductCount = String(candidates.length);
    const guidedOnly = routeTechnical.customerFilterState === 'guided-only' || route.customerFilterState === 'guided-only';
    const filters = document.createElement('div');
    filters.className = 'usac-source-discovery__filters';
    const filterIntro = document.createElement('button');
    filterIntro.type = 'button';
    filterIntro.className = 'usac-source-discovery__filter-intro';
    filterIntro.dataset.filterDisclosure = 'prominent';
    // The exact part-number control below is the renderer for the approved
    // manufacturer_part_number identity field. It is deliberately not emitted
    // as thousands of facet chips, while it remains in the technical asset's
    // exact-resolution proof.
    const selectableFilters = (routeTechnical.filters || []).filter((filter) => (
      filter.key !== 'manufacturer_part_number'
    ));
    const filterCount = selectableFilters.length;
    filterIntro.innerHTML = '<span><strong>Choose by specification</strong><span>Open ' + filterCount + ' verified filters to narrow ' + candidates.length + ' products to one exact part.</span></span>';
    filterIntro.setAttribute('aria-expanded', 'false');
    const filterControls = document.createElement('div');
    filterControls.className = 'usac-source-discovery__filter-controls';
    filterControls.id = 'usac-discovery-filter-controls-' + Math.random().toString(36).slice(2);
    filterIntro.setAttribute('aria-controls', filterControls.id);
    filterIntro.addEventListener('click', () => {
      filterControls.hidden = !filterControls.hidden;
      filterIntro.setAttribute('aria-expanded', String(!filterControls.hidden));
    });
    if (!guidedOnly && filterCount) filters.appendChild(filterIntro);
    const results = document.createElement('div');
    results.className = 'usac-source-discovery__results';
    const status = document.createElement('div');
    status.className = 'usac-source-discovery__status';
    const selected = {};
    let exactSku = '';
    selectableFilters.forEach((filter) => {
      const requested = query.get('spec_' + filter.key);
      if (requested && filter.distinctValues.includes(requested)) selected[filter.key] = requested;
    });

    if (activeChoice) {
      heading.textContent = activeChoice.label;
      copy.textContent = activeChoice.description + ' These results remain limited to the exact imported WAGO classification.';
      const back = document.createElement('a');
      back.className = 'usac-source-discovery__back';
      back.href = activeSourceTag ? '/collections/wago-automation' : '/collections/wago';
      back.textContent = activeSourceTag ? '← All WAGO automation families' : '← All WAGO product categories';
      root.append(heading, copy, back);
    } else {
      root.append(heading, copy);
      if (
        ((root.dataset.collectionHandle === 'leuze-fiber-optic' || root.dataset.collectionHandle === 'leuze-photoelectric') && query.get('family'))
        || activePanasonicHmiFamily
        || activeWagoHmiFamily
        || activeWagoInterfaceFamily
      ) {
        const back = document.createElement('a');
        back.className = 'usac-source-discovery__back';
        back.href = activePanasonicHmiFamily
          ? '/collections/panasonic-hmi'
          : activeWagoHmiFamily
            ? '/collections/wago-hmi'
          : activeWagoInterfaceFamily
            ? '/collections/wago?hub=interface-electronic'
            : root.dataset.collectionHandle === 'leuze-photoelectric'
              ? '/collections/leuze-photoelectric'
              : '/collections/leuze-fiber-optic';
        back.textContent = activePanasonicHmiFamily
          ? '← All current Panasonic HMI series'
          : activeWagoHmiFamily
            ? '← All WAGO TP600 HMI series'
          : activeWagoInterfaceFamily
            ? '← All WAGO Interface Electronic families'
            : root.dataset.collectionHandle === 'leuze-photoelectric'
              ? '← All Leuze photoelectric classifications'
              : '← All fiber optic component types';
        root.appendChild(back);
      }
    }

    const exactPart = document.createElement('label');
    exactPart.className = 'usac-source-discovery__exact';
    exactPart.textContent = 'Search by exact manufacturer part number';
    const exactInput = document.createElement('input');
    exactInput.className = 'usac-source-discovery__exact-input';
    const exactPartNumberFilter = (routeTechnical.filters || []).find((filter) => (
      filter.key === 'manufacturer_part_number'
    ));
    exactInput.dataset.filterKey = 'manufacturer_part_number';
    exactInput.dataset.filterCoverage = String(exactPartNumberFilter?.coverage ?? '');
    exactInput.type = 'search';
    exactInput.autocomplete = 'off';
    exactInput.placeholder = 'Enter an exact part number';
    exactInput.setAttribute('aria-label', 'Exact manufacturer part number');
    const isWago873 = root.dataset.sourceRoute === 'wago-873-series';
    const pluggableSelectorRoutes = new Set([
      'wago-picomax-connectors',
      'wago-mcs-connectors',
      'wago-din-rail-device-plug-connectors',
    ]);
    const isPluggableSelector = pluggableSelectorRoutes.has(root.dataset.sourceRoute);
    const selectionData = (action, selectedSku = '') => {
      const product = selectedSku && candidates.find((candidate) => candidate.sku === selectedSku);
      const data = {
        action,
        pole: selected.poles || product?.technical.poles || 'all',
        marking: selected.connection_marking || product?.technical.connection_marking || 'all',
      };
      if (selectedSku) data.selected_sku = selectedSku;
      return data;
    };
    const trackWago873 = (action, selectedSku = '') => {
      if (!isWago873) return;
      try { window.umami?.track('wago_873_selector_interaction', selectionData(action, selectedSku)); } catch {}
    };
    const trackPluggableSelector = (action, exactSku = '') => {
      if (!isPluggableSelector) return;
      const data = {
        route_key: root.dataset.sourceRoute,
        action,
        selected_facet_keys: Object.keys(selected).filter((key) => selected[key]).sort().join(','),
      };
      if (exactSku) data.exact_sku = exactSku;
      try { window.umami?.track('wago_pluggable_selector_interaction', data); } catch {}
    };
    const exactMatchSku = () => {
      const matches = candidates.filter((candidate) => Object.entries(selected).every(([key, value]) => (
        !value || (Array.isArray(candidate.technical[key]) ? candidate.technical[key].includes(value) : candidate.technical[key] === value)
      )) && (!exactSku || normalizeSku(candidate.sku) === exactSku));
      return matches.length === 1 ? matches[0].sku : '';
    };
    exactInput.addEventListener('input', () => { exactSku = normalizeSku(exactInput.value); renderRows(); });
    exactPart.appendChild(exactInput);
    const exactPartAssistive = [];
    if (routeTechnical.exactPartNumberSearch?.mode === 'typeahead') {
      const list = document.createElement('datalist');
      list.id = 'usac-part-number-options-' + Math.random().toString(36).slice(2);
      const partNumberFilter = (routeTechnical.filters || []).find((filter) => (
        filter.key === 'manufacturer_part_number'
      ));
      (partNumberFilter?.distinctValues || []).forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        list.appendChild(option);
      });
      const hint = document.createElement('div');
      hint.id = list.id + '-hint';
      hint.className = 'usac-source-discovery__exact-hint';
      hint.textContent = 'Start typing, then choose an exact part number from the suggestions.';
      exactInput.setAttribute('list', list.id);
      exactInput.setAttribute('aria-describedby', hint.id);
      exactInput.placeholder = 'Start typing a part number';
      exactPartAssistive.push(list, hint);
    }

    selectableFilters.forEach((filter) => {
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'usac-source-discovery__filter';
      fieldset.dataset.filterKey = filter.key;
      fieldset.dataset.filterCoverage = String(filter.coverage);
      const legend = document.createElement('legend');
      legend.textContent = filter.coverage < 1
        ? filter.label + ' (' + filter.availableCount + ' specified)'
        : filter.label;
      const options = document.createElement('div');
      options.className = 'usac-source-discovery__filter-options';
      filter.distinctValues.forEach((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'usac-source-discovery__filter-chip';
        const label = filterValueLabel(filter.key, value);
        if (root.dataset.collectionHandle === 'wago-221-series-lever-nuts' && filter.key === 'poles' && ['2', '3', '5'].includes(String(value))) {
          const image = document.createElement('img');
          image.src = assetBase + ({ '2': 'usac-wago-221-412.png', '3': 'usac-wago-221-413.png', '5': 'usac-wago-221-415.png' })[String(value)];
          image.alt = 'WAGO 221 ' + value + '-conductor connector';
          image.loading = 'lazy';
          button.append(image, document.createTextNode(label + '-conductor'));
        } else {
        button.textContent = label;
        }
        button.dataset.filterValue = value;
        button.setAttribute('aria-pressed', String(selected[filter.key] === value));
        button.addEventListener('click', () => {
          selected[filter.key] = selected[filter.key] === value ? '' : value;
          [...options.children].forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.filterValue === selected[filter.key])));
          renderRows();
          trackWago873('selector_choice', exactMatchSku());
          trackPluggableSelector('filter_change');
        });
        options.appendChild(button);
      });
      fieldset.append(legend, options);
      filterControls.appendChild(fieldset);
    });
    const reset = document.createElement('button');
    reset.type = 'button';
    reset.className = 'usac-source-discovery__reset';
    reset.textContent = 'Reset technical filters';
    reset.addEventListener('click', () => {
      trackWago873('clear_filters', exactMatchSku());
      trackPluggableSelector('clear_filters');
      Object.keys(selected).forEach((key) => { selected[key] = ''; });
      exactSku = '';
      exactInput.value = '';
      filters.querySelectorAll('[data-filter-value]').forEach((chip) => chip.setAttribute('aria-pressed', 'false'));
      renderRows();
    });
    if (filterCount) filterControls.appendChild(reset);
    if (!guidedOnly && filterCount) filters.appendChild(filterControls);
    filters.append(exactPart, ...exactPartAssistive);
    const hasInitialSelection = Object.values(selected).some(Boolean);
    filterControls.hidden = !hasInitialSelection;
    filterIntro.setAttribute('aria-expanded', String(hasInitialSelection));

    function renderRows() {
      const nextUrl = new URL(window.location.href);
      selectableFilters.forEach((filter) => {
        const key = 'spec_' + filter.key;
        if (selected[filter.key]) nextUrl.searchParams.set(key, selected[filter.key]);
        else nextUrl.searchParams.delete(key);
      });
      window.history.replaceState({}, '', nextUrl);
      results.replaceChildren(status);
      const hasTechnicalSelection = Object.values(selected).some(Boolean);
      if (!exactSku && !hasTechnicalSelection && !activeSourceTag && !activePanasonicHmiFamily && !activeWagoHmiFamily && !activeWagoInterfaceFamily) {
        status.textContent = guidedOnly
          ? 'Enter an exact manufacturer part number to continue.'
          : 'Enter an exact manufacturer part number or select a validated technical requirement before product matches are shown.';
        return;
      }
      const matches = candidates.filter((candidate) => (
        (!exactSku || normalizeSku(candidate.sku) === exactSku)
        && Object.entries(selected).every(([key, value]) => (
          !value
          || (Array.isArray(candidate.technical[key])
            ? candidate.technical[key].includes(value)
            : candidate.technical[key] === value)
        ))
      ));
      const exactMotor = exactSku && matches.length === 1 && matches[0].technical.unit_type === 'Servo motor'
        ? matches[0]
        : null;
      if (exactMotor && routeTechnical.compatibility?.selectionRequirement === 'exact-motor-sku') {
        const panel = document.createElement('section');
        panel.className = 'usac-source-discovery__compatibility';
        const panelHeading = document.createElement('strong');
        panelHeading.textContent = 'Compatible MINAS A6 drivers';
        const compatibleDrivers = routeTechnical.compatibility.byMotorSku?.[exactMotor.sku] || [];
        const quote = document.createElement('a');
        quote.className = 'usac-source-discovery__compatibility-quote';
        quote.href = routeTechnical.compatibility.requestQuoteUrl;
        quote.textContent = 'Request a source-checked motor and driver quote →';
        if (compatibleDrivers.length) {
          const panelCopy = document.createElement('p');
          panelCopy.textContent = 'Panasonic lists these imported driver choices for the exact motor selected. Choose the control interface required by your system.';
          const options = document.createElement('div');
          options.className = 'usac-source-discovery__compatibility-options';
          compatibleDrivers.forEach((driver) => {
            const driverCandidate = candidates.find((candidate) => normalizeSku(candidate.sku) === normalizeSku(driver.sku));
            const link = document.createElement('a');
            link.href = driverCandidate ? productUrl(driverCandidate, exactSkuIndex) : quote.href;
            link.textContent = driver.sku;
            link.title = driver.title;
            options.appendChild(link);
          });
          panel.append(panelHeading, panelCopy, options, quote);
        } else {
          const panelCopy = document.createElement('p');
          panelCopy.textContent = 'This exact motor does not have an unambiguous, imported driver pairing in the approved combination tables. Request a source check before ordering.';
          panel.append(panelHeading, panelCopy, quote);
        }
        results.appendChild(panel);
      }
      selectableFilters.forEach((filter) => {
        filters.querySelectorAll('[data-filter-key="' + filter.key + '"] [data-filter-value]').forEach((chip) => {
          const count = candidates.filter((candidate) => Object.entries(selected).every(([key, value]) => (
            key === filter.key || !value || (Array.isArray(candidate.technical[key]) ? candidate.technical[key].includes(value) : candidate.technical[key] === value)
          )) && (Array.isArray(candidate.technical[filter.key]) ? candidate.technical[filter.key].includes(chip.dataset.filterValue) : candidate.technical[filter.key] === chip.dataset.filterValue)).length;
          chip.textContent = filterValueLabel(filter.key, chip.dataset.filterValue) + ' (' + count + ')';
          chip.disabled = count === 0 && selected[filter.key] !== chip.dataset.filterValue;
        });
      });
      if (matches.length > 1) {
        status.textContent = matches.length + ' source-classified products match your requirements. Compare the exact parts below.';
        const collision = document.createElement('div');
        collision.className = 'usac-source-discovery__collision';
        const collisionHeading = document.createElement('strong');
        const collisionCopy = document.createElement('p');
        const collisionOptions = document.createElement('div');
        collisionOptions.className = 'usac-source-discovery__collision-options';
        selectableFilters.forEach((filter) => {
          if (selected[filter.key]) return;
          const values = [...new Set(matches.map((candidate) => candidate.technical[filter.key]).filter(Boolean))];
          if (values.length < 2) return;
          values.forEach((value) => {
            const option = document.createElement('button');
            option.type = 'button';
            option.textContent = filter.label + ': ' + filterValueLabel(filter.key, value);
            option.addEventListener('click', () => {
              selected[filter.key] = value;
              filters.querySelectorAll('[data-filter-key="' + filter.key + '"] [data-filter-value]').forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.filterValue === value)));
              renderRows();
              trackWago873('selector_choice', exactMatchSku());
              trackPluggableSelector('filter_change');
            });
            collisionOptions.appendChild(option);
          });
        });
        if (collisionOptions.childElementCount) {
          collisionHeading.textContent = 'One more distinction is available';
          collisionCopy.textContent = 'These products share the selected specifications. Choose a remaining source-backed difference below, or compare the exact parts that remain.';
          collision.append(collisionHeading, collisionCopy, collisionOptions);
        } else {
          collisionHeading.textContent = 'Compare the remaining exact parts';
          collisionCopy.textContent = 'These products share every published specification. Review the exact product list below and choose by manufacturer part number.';
          collision.append(collisionHeading, collisionCopy);
        }
        results.appendChild(collision);
      } else {
        status.textContent = matches.length + ' source-classified products match your requirements.';
      }
      const showImages = root.dataset.collectionHandle === 'leuze-fiber-optic'
        || root.dataset.sourceRoute === 'wago-2773-series';
      const resultLimit = showImages ? 24 : 100;
      root.dataset.matchingSkus = JSON.stringify(matches.map((candidate) => candidate.sku));
      matches.slice(0, resultLimit).forEach((candidate) => {
        const row = document.createElement('div');
        row.className = 'usac-source-discovery__result';
        const link = document.createElement('a');
        link.href = productUrl(candidate, exactSkuIndex);
        link.textContent = candidate.title;
        link.addEventListener('click', () => trackWago873('exact_product_click', candidate.sku));
        link.addEventListener('click', () => trackPluggableSelector('exact_product_click', candidate.sku));
        const body = document.createElement('div');
        body.className = 'usac-source-discovery__result-body';
        body.appendChild(link);
        const details = (routeTechnical.filters || [])
          .map((filter) => candidate.technical[filter.key] ? filter.label + ': ' + candidate.technical[filter.key] : '')
          .filter(Boolean);
        if (details.length) {
          const detail = document.createElement('small');
          detail.className = 'usac-source-discovery__result-details';
          detail.textContent = details.join(' · ');
          body.appendChild(detail);
        }
        const sku = document.createElement('span');
        sku.textContent = 'Part # ' + candidate.sku;
        if (showImages) {
          row.classList.add('usac-source-discovery__result--with-image');
          const media = document.createElement('a');
          media.className = 'usac-source-discovery__result-image';
          media.href = link.href;
          media.setAttribute('aria-label', 'View ' + candidate.title);
          media.addEventListener('click', () => trackWago873('exact_product_click', candidate.sku));
          media.addEventListener('click', () => trackPluggableSelector('exact_product_click', candidate.sku));
          row.append(media, body, sku);
          productImage(candidate, exactSkuIndex, assetBase).then((src) => {
            if (!src) return;
            const image = document.createElement('img');
            image.src = src;
            image.alt = candidate.title;
            image.loading = 'lazy';
            media.appendChild(image);
          });
        } else {
          row.append(body, sku);
        }
        results.appendChild(row);
      });
      if (matches.length > resultLimit) {
        const more = document.createElement('div');
        more.className = 'usac-source-discovery__status';
        more.textContent = 'Showing the first ' + resultLimit + ' verified products. Refine one more requirement or enter the exact part number to narrow the list.';
        results.appendChild(more);
      }
    }

    root.append(filters, results);
    renderRows();
  }

  function renderPanasonicFamilyChoice(root) {
    root.replaceChildren();
    const heading = document.createElement('h2');
    heading.textContent = 'Choose an exact Panasonic PLC family';
    const copy = document.createElement('p');
    copy.textContent = 'Use the FP0R, FP0H, FP-XH, FP7, FP-X0, or GM1 family links above. Each family result is independently source-classified rather than filtered through the broad PLC collection.';
    root.append(heading, copy);
  }

  function hideUnsafeFallbackCatalog() {
    const handle = window.location.pathname.split('/').filter(Boolean).pop();
    if (!controlledHandles.has(handle)) return;
    const catalog = document.querySelector('.usac-catalog-layout');
    if (!catalog) return;
    const replacement = document.createElement('section');
    replacement.className = 'usac-guided-only';
    replacement.innerHTML = '<h2>Choose a family before comparing parts</h2><p>USAC is not showing an unverified Shopify collection here. Select a source-classified product family above or search an exact manufacturer part number.</p>';
    catalog.replaceWith(replacement);
  }

  async function initializeDiscovery(root) {
    if (root.dataset.sourceDiscoveryInitialized === 'true') return;
    root.dataset.sourceDiscoveryInitialized = 'true';
    root.dataset.sourceDiscoveryStage = 'renderer-startup';
    try {
      root.dataset.sourceDiscoveryStage = 'manifest-fetch';
      const manifestResponse = await fetch(root.dataset.manifestUrl, { headers: { Accept: 'application/json' } });
      if (!manifestResponse.ok) throw new Error('Unable to load source membership manifest.');
      const manifest = await manifestResponse.json();
      const routeKey = requestedRouteKey(root, manifest);
      const route = manifest.routes?.[routeKey];
      if (!route) throw new Error('This collection has no approved source membership.');
      let routeTechnical = {};
      if (root.dataset.technicalUrl) {
        root.dataset.sourceDiscoveryStage = 'manifest-fetch';
        const technicalResponse = await fetch(root.dataset.technicalUrl, { headers: { Accept: 'application/json' } });
        if (technicalResponse.ok) routeTechnical = (await technicalResponse.json()).routes?.[routeKey] || {};
      }
      const requiresExactSkuIndex = (route.candidates || []).some((candidate) => !candidate.handle);
      let exactSkuIndex = {};
      if (requiresExactSkuIndex && window.USAC_EXACT_SKU_INDEX_URL) {
        root.dataset.sourceDiscoveryStage = 'manifest-fetch';
        const exactResponse = await fetch(window.USAC_EXACT_SKU_INDEX_URL, { headers: { Accept: 'application/json' } });
        if (exactResponse.ok) exactSkuIndex = await exactResponse.json();
      }
      root.dataset.sourceDiscoveryStage = 'renderer-startup';
      renderDiscovery(root, route, routeTechnical, exactSkuIndex);
      root.dataset.sourceDiscoveryStage = 'ready';
    } catch {
      root.dataset.sourceDiscoveryStage = 'error';
      root.replaceChildren();
      root.innerHTML = '<h2>Product membership is under review</h2><p>USAC is not showing this collection until its manufacturer classifications are verified. Search an exact part number or contact our application team for help.</p>';
    }
  }

  function startDiscovery() {
    ensureDiscoveryStyles();
    document.querySelectorAll('[data-usac-source-discovery]').forEach((root) => {
      const handle = root.dataset.collectionHandle;
      const steps = root.parentElement?.querySelector('.usac-discovery-steps');
      if (['wago-splicing-connectors', 'wago-automation', 'leuze-fiber-optic', 'panasonic'].includes(handle)) {
        document.querySelectorAll('.usac-discovery-steps').forEach((step) => step.remove());
      }
      if (handle === 'wago-221-series-lever-nuts' && steps) root.insertAdjacentElement('afterend', steps);
      initializeDiscovery(root);
    });
    hideUnsafeFallbackCatalog();
  }
  window.USACSourceDiscovery = { initialize: initializeDiscovery };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startDiscovery);
  else startDiscovery();
  document.addEventListener('usac:source-discovery-ready', (event) => {
    const root = event.detail?.root;
    if (root?.matches?.('[data-usac-source-discovery]')) initializeDiscovery(root);
  });
})();